import React from 'react';
import { ExpertOfferListCard } from 'src/areas/expert/components/expert-offer-list-card';
import type {
  PrismicRichText,
  PrismicSliceProduct,
} from '../../../../../types';

import * as S from './styles';

type Props = PrismicSliceProduct;

const isPrismicRichText = (obj: any): obj is PrismicRichText =>
  obj &&
  typeof obj.text === 'string' &&
  typeof obj.type === 'string' &&
  Array.isArray(obj.spans);

const Product = ({ title, product }: Props) => {
  if (!product) {
    return null;
  }
  const titleData =
    title && isPrismicRichText(title[0]) && title[0].text.length > 0
      ? title
      : [
          {
            spans: [],
            text: product.name,
            type:
              title && isPrismicRichText(title[0]) ? title[0].type : 'heading2',
          },
        ];
  return (
    <S.Container>
      <S.Title data={titleData} />
      <ExpertOfferListCard
        name={product.name}
        id={product.id}
        imageSrc={product.media?.first}
        link={product.pathName}
        rating={product.userReviewSummary.rating}
        rank={product.popularity?.inCategory}
        reviewsCount={product.userReviewSummary.count}
        prices={product.prices}
        campaignProducts={{}}
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onClick={() => {}}
      />
    </S.Container>
  );
};

export default Product;
